import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SITE } from "@/site";

const LINKS = [
  { to: "/", label: "Home", testId: "nav-home-link" },
  { to: "/treatments", label: "Treatments", testId: "nav-treatments-link" },
  { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 sm:h-[72px] max-w-6xl items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 hover:text-sky-600 ${
                  isActive ? "text-sky-600" : "text-slate-600"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            data-testid="header-call-cta-button"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-navy-800 hover:-translate-y-0.5"
          >
            <Phone size={15} strokeWidth={2.4} />
            {SITE.phoneDisplay}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-navy"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav
          className="md:hidden border-t border-slate-100 bg-white px-5 py-4"
          aria-label="Mobile"
          data-testid="mobile-nav-menu"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`${l.testId}-mobile`}
              className={({ isActive }) =>
                `block rounded-lg px-3 py-3 text-base font-medium ${
                  isActive ? "bg-sky-50 text-sky-700" : "text-slate-700"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
